export default __webpack_public_path__ + "static/media/Entira_Clinic_Card_Brochure.c3e8e582.pdf";